import { Injectable } from '@angular/core';
export interface SearchItem {
  id: string;
  label: string;
}


@Injectable({
  providedIn: 'root',
})
export class SearchService {
  public term: string;
  public qteProducts: number = 0;

  constructor() {}

  public setTerm(term: string, qteProducts: number) {
    this.term = term;
    this.qteProducts = qteProducts;
  }

  public clearTerm() {
    this.term = undefined;
    this.qteProducts = 0;
  }
}
